module.exports = __webpack_public_path__ + "static/media/right.d90aabd8.svg";